import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICampaign } from '../../../shared/interfaces/i-campaign';
import { WebappService } from '../../../shared/services/webapp.service';
import { ICategory } from '../../../shared/interfaces/i-category';
import { CATEGORIES } from '../../../shared/utils/categories';

@Component({
  selector: 'mobo-category',
  templateUrl: './category.component.html',
  styles: [],
})
export class CategoryComponent {
  campaigns?: ICampaign[];
  category?: ICategory;
  categories?: ICategory[] = CATEGORIES;
  constructor(
    public webappService: WebappService,
    public route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.params.subscribe((param) => {
      const categorySlug = param['slug'];
      const cityId = this.webappService.selectedCity.value;
      this.category = this.webappService.categories.value.find(
        (x) => x.Slug === categorySlug
      );
      const categoryId = this.category?.Id || this.category?.CategoriesIds;
      if (cityId && categoryId) {
        this.getRestaurantById(cityId, categoryId);
      }
    });
  }

  async getRestaurantById(cityId: string, categoryId: string) {
    this.campaigns = (await this.webappService.getCategory(
      cityId,
      categoryId
    )) as ICampaign[];
  }
}
